export default __webpack_public_path__ + "static/media/logo.0bfb8c96.svg";